import { useFindingOnAsset } from "~/pages/findings/FindingOnAsset/hooks";
import { Grid } from "@mui/material";
import { SectionHeading } from "~/components/DetailsPage/components";
import { CheckRemediation } from "~/pages/space/security/components/Check/CheckRemediation/CheckRemediation";
import { REMEDIATION_SECTION_ID } from "~/components/Remediation/RemediationJumToButton/RemediationJumpToButton";

export const AssetCheckRemediation = () => {
  const { checkRemediation } = useFindingOnAsset();

  const hasRemediations = checkRemediation.entries.length > 0;

  if (!hasRemediations) return;

  return (
    <Grid size={12}>
      <SectionHeading heading="Remediation" id={REMEDIATION_SECTION_ID} />
      <CheckRemediation entries={checkRemediation.entries} />
    </Grid>
  );
};
